let menuOpen = false;
const menu = <HTMLElement>document.querySelector(".secondary-mobile-nav");
const button = <HTMLElement>document.getElementById("mobile-nav");

const swapIcon = () => {
    if (menuOpen) {
        let icon = button.querySelector('i')
        icon.classList.remove('fa-bars');
        icon.classList.add('fa-times');

        button.classList.add('active');
        button.parentElement.classList.add('active');
    } else {
        let icon = button.querySelector('i')
        icon.classList.remove('fa-times');
        icon.classList.add('fa-bars');

        button.classList.remove('active');
        button.parentElement.classList.remove('active');
    }
}

if (button) {
    button.addEventListener("click", (ev) => {
        ev.preventDefault();

        if (menuOpen) {
            menu.classList.add('d-none');
            menuOpen = false;
        } else {
            menu.classList.remove('d-none');
            menuOpen = true;
        }

        swapIcon();
    })
}
